// AI Book Generation Constants
export const GENAI_GENERATE_REQUEST = 'GENAI_GENERATE_REQUEST';
export const GENAI_GENERATE_SUCCESS = 'GENAI_GENERATE_SUCCESS';
export const GENAI_GENERATE_FAIL = 'GENAI_GENERATE_FAIL';
export const GENAI_GENERATE_RESET = 'GENAI_GENERATE_RESET';

export const GENAI_JOB_DETAILS_REQUEST = 'GENAI_JOB_DETAILS_REQUEST';
export const GENAI_JOB_DETAILS_SUCCESS = 'GENAI_JOB_DETAILS_SUCCESS';
export const GENAI_JOB_DETAILS_FAIL = 'GENAI_JOB_DETAILS_FAIL';

export const GENAI_MY_JOBS_REQUEST = 'GENAI_MY_JOBS_REQUEST';
export const GENAI_MY_JOBS_SUCCESS = 'GENAI_MY_JOBS_SUCCESS';
export const GENAI_MY_JOBS_FAIL = 'GENAI_MY_JOBS_FAIL';

export const GENAI_TEMPLATES_REQUEST = 'GENAI_TEMPLATES_REQUEST';
export const GENAI_TEMPLATES_SUCCESS = 'GENAI_TEMPLATES_SUCCESS';
export const GENAI_TEMPLATES_FAIL = 'GENAI_TEMPLATES_FAIL';

export const GENAI_DELETE_JOB_REQUEST = 'GENAI_DELETE_JOB_REQUEST';
export const GENAI_DELETE_JOB_SUCCESS = 'GENAI_DELETE_JOB_SUCCESS';
export const GENAI_DELETE_JOB_FAIL = 'GENAI_DELETE_JOB_FAIL';

// Workflow Actions - Story Review
export const GENAI_STORY_REQUEST = 'GENAI_STORY_REQUEST';
export const GENAI_STORY_SUCCESS = 'GENAI_STORY_SUCCESS';
export const GENAI_STORY_FAIL = 'GENAI_STORY_FAIL';

export const GENAI_APPROVE_STORY_REQUEST = 'GENAI_APPROVE_STORY_REQUEST';
export const GENAI_APPROVE_STORY_SUCCESS = 'GENAI_APPROVE_STORY_SUCCESS';
export const GENAI_APPROVE_STORY_FAIL = 'GENAI_APPROVE_STORY_FAIL';

export const GENAI_REGENERATE_STORY_REQUEST = 'GENAI_REGENERATE_STORY_REQUEST';
export const GENAI_REGENERATE_STORY_SUCCESS = 'GENAI_REGENERATE_STORY_SUCCESS';
export const GENAI_REGENERATE_STORY_FAIL = 'GENAI_REGENERATE_STORY_FAIL';

// Workflow Actions - Cover Review
export const GENAI_IMAGES_REQUEST = 'GENAI_IMAGES_REQUEST';
export const GENAI_IMAGES_SUCCESS = 'GENAI_IMAGES_SUCCESS';
export const GENAI_IMAGES_FAIL = 'GENAI_IMAGES_FAIL';

export const GENAI_REGENERATE_COVER_REQUEST = 'GENAI_REGENERATE_COVER_REQUEST';
export const GENAI_REGENERATE_COVER_SUCCESS = 'GENAI_REGENERATE_COVER_SUCCESS';
export const GENAI_REGENERATE_COVER_FAIL = 'GENAI_REGENERATE_COVER_FAIL';

// Workflow Actions - Pages Review
export const GENAI_APPROVE_PAGES_REQUEST = 'GENAI_APPROVE_PAGES_REQUEST';
export const GENAI_APPROVE_PAGES_SUCCESS = 'GENAI_APPROVE_PAGES_SUCCESS';
export const GENAI_APPROVE_PAGES_FAIL = 'GENAI_APPROVE_PAGES_FAIL';

export const GENAI_REGENERATE_PAGE_REQUEST = 'GENAI_REGENERATE_PAGE_REQUEST';
export const GENAI_REGENERATE_PAGE_SUCCESS = 'GENAI_REGENERATE_PAGE_SUCCESS';
export const GENAI_REGENERATE_PAGE_FAIL = 'GENAI_REGENERATE_PAGE_FAIL';
export const GENAI_REGENERATE_PAGE_RESET = 'GENAI_REGENERATE_PAGE_RESET';
export const GENAI_REGENERATE_COVER_RESET = 'GENAI_REGENERATE_COVER_RESET';

// Workflow Actions - Final Review
export const GENAI_APPROVE_FINAL_REQUEST = 'GENAI_APPROVE_FINAL_REQUEST';
export const GENAI_APPROVE_FINAL_SUCCESS = 'GENAI_APPROVE_FINAL_SUCCESS';
export const GENAI_APPROVE_FINAL_RESET = 'GENAI_APPROVE_FINAL_RESET';

// Retry failed/stuck job
export const GENAI_RETRY_JOB_REQUEST = 'GENAI_RETRY_JOB_REQUEST';
export const GENAI_RETRY_JOB_SUCCESS = 'GENAI_RETRY_JOB_SUCCESS';
export const GENAI_RETRY_JOB_FAIL = 'GENAI_RETRY_JOB_FAIL';
export const GENAI_APPROVE_FINAL_FAIL = 'GENAI_APPROVE_FINAL_FAIL';
